import React from 'react';
import { withRouter } from 'react-router-dom';
import { Bold, Paragraph, ClickableBoxWithUnderline } from '../Components';
import { getGenreParam } from '../utils/getSearchParam';
import { navigateToProductListWithGenre } from '../utils/navigations';
import { getTranslateByScope } from '../i18n';

export const translate = getTranslateByScope('app.genres');
export const Genre = withRouter(({
  history, value, isActive, onMouseEnter, ...props
}) => {
  const genre = getGenreParam(props.location);
  // isActive lets the menu highlight the hovered genre instead of the current one
  const isCurrent = isActive === undefined ? genre === value : isActive;
  const onClick = () => {
    navigateToProductListWithGenre({
      genre: value,
      history,
    });
  };
  return (
    <ClickableBoxWithUnderline
      isUnderlined={isCurrent}
      onClick={onClick}
      onMouseEnter={onMouseEnter}>
      {/* 1804Ginto has no 500 weight, so the default Bold looks regular */}
      {isCurrent ? (
        <Bold style={{ fontWeight: 700 }}>{translate(value)}</Bold>
      ) : (
        <Paragraph>{translate(value)}</Paragraph>
      )}
    </ClickableBoxWithUnderline>
  );
});
